// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"925b8714","732":"2afdbfa8","977":"1a00eae3"}[chunkId] + ".chunk.js");